import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';

import { AUTHORIZATION_STATUS_FILTER } from './dataprev-employee.enums';

// Filtros da Gestão de autorizações declarados uma vez (P01): o "Filtrar por" do legado
// (`AuthorizationListContainer.tsx:66-86`, `AuthorizationFilters.tsx:28-104`). Arquivo leve (JS inicial).
// A data vai como o `filterContext`: início `T00:00:00-03:00`, fim `T23:59:59.999999-03:00`, o fim antes.
// O CPF é texto livre, enviado como foi digitado, com ou sem máscara (`AuthorizationListContainer.tsx:69`,
// `AuthorizationFilters.tsx:41-52`; revisão !11102, R2).

export const authorizationFilters = defineFilters([
  { key: 'registrationNumber', type: 'text', label: msg`CPF` },
  { key: 'phoneNumber', type: 'text', label: msg`Whatsapp`, max: 20 },
  { key: 'status', type: 'select', label: msg`Status da solicitação`, options: AUTHORIZATION_STATUS_FILTER },
  { key: 'initialDate', to: 'finalDate', type: 'dateRange', label: msg`Data de solicitação`, fromLabel: msg`Data inicial`, toLabel: msg`Data final` },
]);
